import React from 'react';
import { getOptions } from '../aggregationUtil';
import { newInteractiveFilter } from './interactiveFilter';
import { filterComposers } from '../../../utils/common';

const getValidComposers = aggregationQuery => {
  return getOptions(aggregationQuery).then(res => {
    if (res?.data) {
      res.data = filterComposers(res.data);
    }
    return res;
  });
};

const Filter = newInteractiveFilter('composer_id', getValidComposers);

export const ComposerInteractiveFilter = ({
  composers,
  aggregationQuery,
  onSelectValue,
  onClearValue,
  label,
  ...additionalProps
}) => (
  <Filter
    options={composers}
    aggregationQuery={aggregationQuery}
    onSelectValue={onSelectValue}
    onClearValue={onClearValue}
    label={label}
    {...additionalProps}
  />
);
